exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2fSrPBVOSbcU-y37JMfYpz {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n._2fSrPBVOSbcU-y37JMfYpz .popover-content {\n    min-width: 200px;\n    padding: 0;\n}\n\n._2fSrPBVOSbcU-y37JMfYpz .list-group {\n    margin-bottom: 0;\n}\n\n._2fSrPBVOSbcU-y37JMfYpz .list-group-item {\n    border-right: 0;\n    border-left: 0;\n    padding: 6px 15px;\n}\n\n._2fSrPBVOSbcU-y37JMfYpz .list-group-item:first-child {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n}\n\n._2fSrPBVOSbcU-y37JMfYpz .list-group-item:last-child {\n    border-bottom: 0;\n}\n\n._32nZd_0WpdzWIDi9xmpS6u {\n    max-height: 340px; /* 10 items */\n    overflow: auto;\n}\n\n._1QfDaivZuv9xU2lH0SLycM {\n    margin-bottom: 0 !important;\n    padding: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"customPopover": "_2fSrPBVOSbcU-y37JMfYpz",
	"scrollableList": "_32nZd_0WpdzWIDi9xmpS6u",
	"dataFilterInput": "_1QfDaivZuv9xU2lH0SLycM"
};